<template>
  <div class="dash" v-loading="loading">
    <template v-if="isCoach">
      <section class="hero">
        <div class="hero-copy">
          <p class="hero-kicker">教练工作台</p>
          <h2 class="hero-title">给到课学员签到</h2>
          <p class="hero-desc">本馆全部小课学员，谁上课谁打卡。可拍照签到，或按名单勾选。</p>
        </div>
        <div class="hero-actions">
          <el-button type="primary" @click="openKiosk(2)">拍照签到</el-button>
          <el-button plain @click="$router.push('/private/punch')">选人签到</el-button>
        </div>
      </section>
      <section class="block">
        <div class="tile-grid">
          <button type="button" class="tile" @click="openKiosk(2)">
            <span class="tile-icon tone-teal"><i class="el-icon-camera"></i></span>
            <span class="tile-body">
              <span class="tile-title">拍照签到</span>
              <span class="tile-desc">比对照片，扣小课</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/private/punch')">
            <span class="tile-icon tone-forest"><i class="el-icon-s-check"></i></span>
            <span class="tile-body">
              <span class="tile-title">选人签到</span>
              <span class="tile-desc">搜索姓名 / 拼音 / 电话，一次多人</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/private/records')">
            <span class="tile-icon tone-forest"><i class="el-icon-time"></i></span>
            <span class="tile-body">
              <span class="tile-title">小课记录</span>
              <span class="tile-desc">上课时间与学员</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
        </div>
      </section>
    </template>

    <template v-else>
      <section class="hero">
        <div class="hero-copy">
          <p class="hero-kicker">课时管理</p>
          <h2 class="hero-title">{{ clubName || '工作台' }}</h2>
          <p class="hero-desc">先查学员剩余课时，再报名或签到。大课、小课、年卡分开管。本后台与小程序管理功能一致，小程序不可用时可直接在这里操作。</p>
        </div>
        <div class="hero-actions">
          <el-button type="primary" @click="$router.push('/students')">查课时</el-button>
          <el-button plain @click="$router.push('/enroll')">报名录入</el-button>
        </div>
      </section>

      <section class="stats">
        <div class="stat">
          <div class="stat-label">大课学员</div>
          <div class="stat-value">{{ counts.group }}</div>
        </div>
        <div class="stat">
          <div class="stat-label">小课学员</div>
          <div class="stat-value">{{ counts.private }}</div>
        </div>
        <div class="stat">
          <div class="stat-label">近期接龙</div>
          <div class="stat-value">{{ counts.sessions }}</div>
        </div>
        <div class="stat">
          <div class="stat-label">快捷入口</div>
          <div class="stat-value text-sm">查课时</div>
        </div>
      </section>

      <section class="block">
        <div class="block-head">
          <h3>查课时</h3>
          <p>所有学员的大课剩余、小课剩余、年卡有效期都在这里</p>
        </div>
        <div class="tile-grid">
          <button type="button" class="tile" @click="$router.push('/students')">
            <span class="tile-icon tone-teal"><i class="el-icon-data-analysis"></i></span>
            <span class="tile-body">
              <span class="tile-title">学员课时</span>
              <span class="tile-desc">大课剩余 · 小课剩余 · 年卡</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/enroll')">
            <span class="tile-icon tone-forest"><i class="el-icon-edit"></i></span>
            <span class="tile-body">
              <span class="tile-title">报名录入</span>
              <span class="tile-desc">新学员 · 大课 / 小课 / 年卡</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
        </div>
      </section>

      <section class="block">
        <div class="block-head">
          <h3>大课日常</h3>
          <p>集体课到场、接龙与签到历史</p>
        </div>
        <div class="tile-grid">
          <button type="button" class="tile" @click="openKiosk(1)">
            <span class="tile-icon tone-teal"><i class="el-icon-camera"></i></span>
            <span class="tile-body">
              <span class="tile-title">拍照签到</span>
              <span class="tile-desc">打开大屏比对，扣除大课课时</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/manual-check-in')">
            <span class="tile-icon tone-forest"><i class="el-icon-edit-outline"></i></span>
            <span class="tile-body">
              <span class="tile-title">选人签到</span>
              <span class="tile-desc">搜索名单，可一次多人</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/group-lesson')">
            <span class="tile-icon tone-amber"><i class="el-icon-date"></i></span>
            <span class="tile-body">
              <span class="tile-title">大课接龙</span>
              <span class="tile-desc">发起场次 · 名单 · 退课</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/check-in-records')">
            <span class="tile-icon tone-slate"><i class="el-icon-time"></i></span>
            <span class="tile-body">
              <span class="tile-title">大课记录</span>
              <span class="tile-desc">拍照 / 选人历史</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
        </div>
      </section>

      <section class="block">
        <div class="block-head">
          <h3>小课日常</h3>
          <p>私教一对一；教练可见全部小课学员，谁上课谁打卡</p>
        </div>
        <div class="tile-grid">
          <button type="button" class="tile" @click="openKiosk(2)">
            <span class="tile-icon tone-teal"><i class="el-icon-camera"></i></span>
            <span class="tile-body">
              <span class="tile-title">拍照签到</span>
              <span class="tile-desc">比对照片，扣除小课课时</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/private/punch')">
            <span class="tile-icon tone-forest"><i class="el-icon-s-check"></i></span>
            <span class="tile-body">
              <span class="tile-title">选人签到</span>
              <span class="tile-desc">搜索多选，馆长可代消</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/private/students')">
            <span class="tile-icon tone-amber"><i class="el-icon-wallet"></i></span>
            <span class="tile-body">
              <span class="tile-title">小课名单/充值</span>
              <span class="tile-desc">余额 · 带课教练可选填</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/private/records')">
            <span class="tile-icon tone-forest"><i class="el-icon-document"></i></span>
            <span class="tile-body">
              <span class="tile-title">小课记录</span>
              <span class="tile-desc">搜索 · 删除</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/coaches')">
            <span class="tile-icon tone-slate"><i class="el-icon-s-custom"></i></span>
            <span class="tile-body">
              <span class="tile-title">教练账号</span>
              <span class="tile-desc">开号后教练登录即可划课</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
        </div>
      </section>

      <section class="block">
        <div class="block-head">
          <h3>通知与设置</h3>
          <p>家长通知、课时核对与系统参数</p>
        </div>
        <div class="tile-grid">
          <button type="button" class="tile" @click="$router.push('/notify')">
            <span class="tile-icon tone-teal"><i class="el-icon-message"></i></span>
            <span class="tile-body">
              <span class="tile-title">发通知</span>
              <span class="tile-desc">训练计划 · 放假 · 上课提醒</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/hour-audit')">
            <span class="tile-icon tone-amber"><i class="el-icon-document-checked"></i></span>
            <span class="tile-body">
              <span class="tile-title">课时对账</span>
              <span class="tile-desc">核对充值与消耗流水</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
          <button type="button" class="tile" @click="$router.push('/settings')">
            <span class="tile-icon tone-slate"><i class="el-icon-setting"></i></span>
            <span class="tile-body">
              <span class="tile-title">系统设置</span>
              <span class="tile-desc">比对阈值 · 抵小课比例 · 提醒</span>
            </span>
            <i class="el-icon-arrow-right tile-arrow"></i>
          </button>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { getStudents, getPrivateStudents, listGroupSessions } from '../api'

export default {
  name: 'Dashboard',
  data() {
    return {
      loading: false,
      counts: { group: '—', private: '—', sessions: '—' }
    }
  },
  computed: {
    clubName() {
      return localStorage.getItem('club_name') || ''
    },
    isCoach() {
      return Number(localStorage.getItem('admin_role') || 1) === 2
    }
  },
  created() {
    if (!this.isCoach) this.loadCounts()
  },
  methods: {
    pickTotal(res) {
      const data = (res && res.data) || {}
      if (data.total != null) return data.total
      const records = data.records || data.list || []
      return Array.isArray(records) ? records.length : '—'
    },
    async loadCounts() {
      this.loading = true
      try {
        const [g, p, sess] = await Promise.all([
          getStudents({ page: 1, size: 1 }),
          getPrivateStudents({ page: 1, size: 1 }),
          listGroupSessions({ page: 1, size: 1, upcomingOnly: true })
        ])
        this.counts = {
          group: this.pickTotal(g),
          private: this.pickTotal(p),
          sessions: this.pickTotal(sess)
        }
      } catch (e) {
        // keep placeholders
      } finally {
        this.loading = false
      }
    },
    openKiosk(courseType) {
      const raw = (localStorage.getItem('club_code') || '').trim()
      if (!raw) {
        this.$message.warning('请先登录并绑定俱乐部')
        return
      }
      const code = encodeURIComponent(raw)
      const type = Number(courseType) === 2 ? 2 : 1
      const base = window.location.href.split('#')[0]
      const hash = '#/kiosk?clubCode=' + code + '&courseType=' + type
      const win = window.open(base + hash, '_blank')
      if (!win) {
        this.$router.push({ path: '/kiosk', query: { clubCode: raw, courseType: String(type) } })
      }
    }
  }
}
</script>

<style scoped>
.dash { max-width: 1080px; }

.hero {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;
  padding: 28px 28px 26px;
  border-radius: 18px;
  background:
    radial-gradient(ellipse 80% 120% at 100% 0%, rgba(20, 184, 166, 0.22), transparent 55%),
    linear-gradient(135deg, #16302C 0%, #0F766E 55%, #115E59 100%);
  color: #fff;
  margin-bottom: 20px;
  overflow: hidden;
  position: relative;
}

.hero::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);
  background-size: 28px 28px;
  pointer-events: none;
  opacity: 0.35;
}

.hero-copy,
.hero-actions { position: relative; z-index: 1; }

.hero-kicker {
  margin: 0 0 8px;
  font-size: 12px;
  letter-spacing: 0.12em;
  color: rgba(255, 255, 255, 0.65);
}

.hero-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  font-family: var(--aw-display);
  letter-spacing: 0.5px;
}

.hero-desc {
  margin: 10px 0 0;
  max-width: 480px;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.78);
}

.hero-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.hero-actions .el-button--primary {
  background: #fff;
  border-color: #fff;
  color: #0F766E;
  font-weight: 600;
}

.hero-actions .el-button.is-plain {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.45);
  color: #fff;
}

.stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 28px;
}

.stat {
  background: var(--aw-surface);
  border: 1px solid var(--aw-line);
  border-radius: var(--aw-radius);
  padding: 16px 18px;
}

.stat-label {
  font-size: 12px;
  color: var(--aw-muted);
}

.stat-value {
  margin-top: 6px;
  font-size: 28px;
  font-weight: 700;
  font-family: var(--aw-display);
  color: var(--aw-ink);
  letter-spacing: -0.5px;
}

.stat-value.text-sm {
  font-size: 16px;
  letter-spacing: 0;
  line-height: 1.4;
}

.block { margin-bottom: 28px; }

.block-head h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--aw-ink);
}

.block-head p {
  margin: 4px 0 14px;
  font-size: 13px;
  color: var(--aw-muted);
}

.tile-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.tile {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  text-align: left;
  padding: 16px 16px 16px 14px;
  border: 1px solid var(--aw-line);
  border-radius: var(--aw-radius);
  background: var(--aw-surface);
  cursor: pointer;
  transition: border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}

.tile:hover {
  border-color: rgba(15, 118, 110, 0.35);
  box-shadow: var(--aw-shadow);
  transform: translateY(-1px);
}

.tile-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.tone-teal { background: rgba(15, 118, 110, 0.12); color: #0F766E; }
.tone-forest { background: rgba(22, 48, 44, 0.1); color: #16302C; }
.tone-amber { background: rgba(180, 83, 9, 0.12); color: #B45309; }
.tone-slate { background: rgba(100, 116, 139, 0.14); color: #475569; }

.tile-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }

.tile-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--aw-ink);
}

.tile-desc {
  font-size: 12px;
  color: var(--aw-muted);
}

.tile-arrow { color: #CBD5E1; font-size: 14px; }

@media (max-width: 800px) {
  .hero {
    flex-direction: column;
    align-items: flex-start;
    padding: 22px;
  }
  .hero-title { font-size: 22px; }
  .stats { grid-template-columns: repeat(2, 1fr); }
  .tile-grid { grid-template-columns: 1fr; }
}
</style>
